'use client';

import React, { useEffect, useState } from 'react';

import { Caption } from '@depop/web-thrift-ui/Typography';
import { CancelIcon } from '@depop/web-ui-kit/Icons/CancelIcon';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

interface PageDescriptionProps {
  text: string;
}

export function PageDescription({ text }: PageDescriptionProps) {
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
  const t = useTranslations('common');
  const isLargeDescription = text.length > 50;
  const shouldShowGradient = isLargeDescription && !isDescriptionExpanded;

  function handleToggleButtonClick() {
    setIsDescriptionExpanded(!isDescriptionExpanded);
  }

  useEffect(() => {
    if (isLargeDescription) {
      setIsDescriptionExpanded(isDescriptionExpanded);
    }
  }, [text]);

  return (
    <article>
      <Caption
        colour="base"
        variant="lg-regular"
        className={styles.description}
        style={
          {
            '--webkitLineClamp': isDescriptionExpanded ? 'unset' : 2,
            '--display': shouldShowGradient ? 'block' : 'none',
            '--breakpointWebkitLineClamp': isDescriptionExpanded ? 'unset' : 1,
          } as React.CSSProperties
        }
        // eslint-disable-next-line no-restricted-syntax
        data-testid="pageDescription"
      >
        {text}
      </Caption>
      {isLargeDescription && (
        <button
          className={styles.toggleDescriptionBtn}
          onClick={handleToggleButtonClick}
        >
          <Caption variant="lg-regular" as="span">
            {isDescriptionExpanded ? (
              <>
                {t('ShowLess')}
                <span className={styles.descriptionCollapseIcon} />
              </>
            ) : (
              <>
                {t('ShowMore')}
                <span className={styles.descriptionExpandIcon}>
                  <CancelIcon size={14} />
                </span>
              </>
            )}
          </Caption>
        </button>
      )}
    </article>
  );
}
